var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('base-header-bar',{attrs:{"logout":_vm.loggedIn}}),_c('v-main',{class:_vm.$style.container,staticStyle:{"background":"#f8f8f8"}},[_c('VRow',{class:_vm.$style.container,attrs:{"justify":"center","align":"center"}},[_vm._t("default")],2)],1),_c('chat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }